import React from "react";

const LocationIcon = (props) => {
  return (
    <svg
      {...props}
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4995 11.753C12.0073 11.753 13.2295 10.5307 13.2295 9.02297C13.2295 7.51523 12.0073 6.29297 10.4995 6.29297C8.99179 6.29297 7.76953 7.51523 7.76953 9.02297C7.76953 10.5307 8.99179 11.753 10.4995 11.753Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M3.16749 7.42875C4.89124 -0.148748 16.1175 -0.139998 17.8325 7.4375C18.8387 11.8825 15.4237 16.6725 13 19C11.2413 20.6975 9.10874 19.67 7.34124 17.9725C4.92624 15.645 2.16124 11.8738 3.16749 7.42875Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default LocationIcon;
